import styled from '@emotion/styled'
import tw from 'twin.macro'
import { Heading, getScreenSizes } from '@pretamanger/component-library'

// TODO confirm if we really need to override the heading style to match the design
export const SubMenuTitle = styled(Heading)`
  ${tw`
    bg-transparent
    font-normal text-pretRed-700 text-center text-lg leading-none lg:text-left lg:leading-6 lg:font-medium
    lg:border-b lg:py-2 lg:px-3
    mb-0 lg:mb-3
  `}
`

export const SideNavContainer = styled('div')`
  ${tw`lg:w-auto lg:ml-auto`}
  @media (min-width: ${getScreenSizes().lg}px) {
    max-width: 18rem;
  }
`

export const CategoriesContainer = styled('div')`
  ${tw`hidden lg:block`}
`
